import { useQuery } from "@tanstack/react-query";

import { supportRequestService } from "@/app/services/supportRequestService";
import { SupportRequestCountsResponse } from "@/app/services/supportRequestService/getSupportRequestCounts";

export const SUPPORT_REQUEST_COUNTS_QUERY_KEY = "supportRequestCounts";

const EMPTY_COUNTS: SupportRequestCountsResponse = {
  open: 0,
  claimable: 0,
  mine: 0,
  inProgress: 0,
  all: 0,
};

interface UseSupportRequestCountsParams {
  enabled?: boolean;
  /**
   * Só quem está sempre montado (o card do menu) liga o polling: cada
   * observador com `refetchInterval` cria o seu próprio timer, e dois timers
   * na mesma chave batem na API duas vezes por minuto. Os outros consumidores
   * leem do cache e se atualizam junto.
   */
  poll?: boolean;
}

export const useSupportRequestCounts = ({
  enabled = true,
  poll = false,
}: UseSupportRequestCountsParams = {}) => {
  const { data } = useQuery({
    queryKey: [SUPPORT_REQUEST_COUNTS_QUERY_KEY],
    queryFn: supportRequestService.getSupportRequestCounts,
    enabled,
    staleTime: 30_000,
    ...(poll && {
      refetchInterval: 60_000,
      refetchIntervalInBackground: true,
    }),
  });

  return data ?? EMPTY_COUNTS;
};
